const authUrl = process.env.REACT_APP_API_AUTH;

export const handleLogin = async (email, password) => {
    try {
        const response = await fetch(
            `${authUrl}/realms/theros/protocol/openid-connect/token`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    client_id: 'theros-public-client',
                    grant_type: 'password',
                    username: email,
                    password: password
                }),
            }
        );

        if (!response.ok) {
            throw new Error('Login failed. Please check your credentials.');
        }
      
        const data = await response.json();
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('token_expires_in', data.expires_in);
        localStorage.setItem('token_saved_at', Date.now());

        return { success: true, token: data.access_token, expires_in: data.expires_in };
    } catch (err) {
        console.error(err);
        return { success: false, error: err.message };
    }
};


export const apiRequest = async (url, method, headers, body) => {
    const response = await fetch(url, {
        method,
        headers,
        body
    });

    if (response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";  // navigation from inside utilities
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
};


export const retrieveAccessToken = () => {
    const token = localStorage.getItem('token');
    const savedAt = localStorage.getItem('token_saved_at');
    const expiresIn = localStorage.getItem('token_expires_in');

    if (!token || isExpired(savedAt, expiresIn)) {
        localStorage.clear();
        window.location.href = "/login";
        return;
    }

    return token;
};


export const isExpired = (savedAt, expiresIn) => {
    if (!savedAt || !expiresIn) return true;

    const now = Date.now();
    const diff = (now - savedAt) / 1000; // seconds

    return diff >= expiresIn;
};

